export function handleFormSubmitApiError(error: any, t: Function) {
    if (error instanceof Error) {
        alert(error.message || t('Form.failedToSubmit'));
    } else alert(t('Form.unknownError'));
}
